import { jsx as _jsx } from "react/jsx-runtime";
import { getRootStore } from "@/stores/RootStore";
import styles from "@/styles/ManufacturersPage.module.less";
import { canDeleteFromDictionaries, canEditDictionaries, } from "@/utils/permissions";
import { Button, Card, Modal, Skeleton, Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";
import { DataTable } from "@/components/DataTable";
import { Filters } from "@/components/filters";
export const ManufacturersPage = observer(() => {
    const { authStore, manufacturersStore } = getRootStore();
    const { dataTable, loading, filtersStore } = manufacturersStore;
    const navigate = useNavigate();
    // Определяем права доступа
    const userRole = authStore.userRole;
    const canEdit = canEditDictionaries(userRole);
    const canDelete = canDeleteFromDictionaries(userRole);
    useEffect(() => {
        dataTable.setFilters(filtersStore.values);
        dataTable.loadData();
    }, [filtersStore.values]);
    const handleViewManufacturer = (manufacturerId) => {
        if (manufacturerId) {
            navigate(`/manufacturers/${manufacturerId}`);
        }
        else {
            navigate("/manufacturers/new");
        }
    };
    const handleDeleteManufacturer = (manufacturerId) => {
        Modal.confirm({
            title: "Удалить производителя?",
            content: "Вы уверены, что хотите удалить этого производителя?",
            okText: "Удалить",
            okType: "danger",
            cancelText: "Отмена",
            onOk: () => manufacturersStore.deleteManufacturer(manufacturerId),
        });
    };
    const columns = [
        {
            title: "Название",
            key: "name",
            sorter: true,
            dataIndex: "name",
            render: (_, record) => (_jsx(Button, { type: "link", onClick: () => handleViewManufacturer(record.id), children: record.name })),
        },
        {
            title: "Контактное лицо",
            dataIndex: "contactPerson",
            key: "contactPerson",
            render: (text) => text || "—",
        },
        {
            title: "Телефон",
            dataIndex: "contactPhone",
            key: "contactPhone",
            render: (text) => text || "—",
        },
        {
            title: "Email",
            dataIndex: "contactEmail",
            key: "contactEmail",
            render: (text) => text || "—",
        },
        {
            title: "Действия",
            key: "actions",
            width: 120,
            render: (_, record) => canDelete && (_jsx(Tooltip, { title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", children: _jsx(Button, { type: "text", icon: _jsx(DeleteOutlined, {}), danger: true, size: "small", onClick: () => handleDeleteManufacturer(record.id) }) })),
        },
    ];
    const dataTableConfig = {
        header: {
            title: "Производители",
            actions: canEdit ? (_jsx(Button, { type: "primary", icon: _jsx(PlusOutlined, {}), onClick: () => handleViewManufacturer(), children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044F" })) : undefined,
            extraContent: (_jsx(Filters, { filtersStore: filtersStore, title: "\u0424\u0438\u043B\u044C\u0442\u0440\u044B \u0438 \u043F\u043E\u0438\u0441\u043A", showClearAll: true, showApplyButton: false })),
        },
        columns: columns,
        rowKey: "id",
        scroll: { x: 800 },
    };
    if (loading) {
        return (_jsx("div", { className: styles.container, children: _jsx(Card, { children: _jsx(Skeleton, { active: true, paragraph: { rows: 8 } }) }) }));
    }
    return _jsx(DataTable, { store: dataTable, config: dataTableConfig });
});
export default ManufacturersPage;
